import { render, staticRenderFns } from "./ClassificationManagementTable.vue?vue&type=template&id=82f3bf0a&scoped=true&"
import script from "./ClassificationManagementTable.vue?vue&type=script&lang=js&"
export * from "./ClassificationManagementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f3bf0a",
  null
  
)

export default component.exports